import React, { useEffect, useState } from "react";

import { client, apiEndpoints, serverUrl } from "../../config";

import PostSingle from "../../partials/posts/postSingle";
import PostImage from "../../partials/postImage";
import ClientTheme from "../../core/clientTheme";

import { Box, Typography, Link } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import TimeIcon from "@mui/icons-material/AccessTimeOutlined";
import CalendarIcon from "@mui/icons-material/CalendarTodayOutlined";
import PhoneIcon from "@mui/icons-material/PhoneOutlined";
import MailIcon from "@mui/icons-material/EmailOutlined";
import LinkIcon from "@mui/icons-material/LinkOutlined";
import PinIcon from "@mui/icons-material/PlaceOutlined";
import Iframe from "../../partials/iframe";

export default function FormSingle(props) {
  const [post, setPost] = useState(null);

  const clientTheme = { ...ClientTheme() };
  return (
    <PostSingle
      preview={props.preview}
      apiEndpoint={apiEndpoints.forms}
      entityFavoritesContentType={"forms"}
      previewReturnRoute={"/forms-creator"}
      returnRoute={"/forms"}
      backBtnText={"Surveys & Forms Library"}
      screenClassName={"forms"}
      logCustomEventType={"forms"}
      entityType={"webform"}
      featuredImageEnabled={true}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
      childrenAfter={
        post?.webform && (post.webform?.machine_name || post.webform?.id) ? (
          <Iframe
            src={`${serverUrl}/form/${(post.webform?.machine_name ?? post.webform?.id).replace(/_/g, "-")}?app=true`}
            title={post.webform.machine_name}
          />
        ) : null
      }
    ></PostSingle>
  );
}
